module.exports = __webpack_public_path__ + "img/2002.8a00e8cf.png";